/**
 * Network component for handling smooth scrolling
 */
export default class SmoothScroll {

  /**
   * Contstructor
   * @param {object} pointerSelector - selector that will trigger scroll
   */
  constructor(pointerSelector) {
    this.pointerSelector = pointerSelector;
  }

  /**
   * Set Smooth Scrolling
   * @todo: consider updating this to not use jQuery
   */
  init() {
    $('body').on('click', this.pointerSelector, (e) => {
      const hash = $(e.currentTarget).attr('href');

      if (/^#/.test(hash)) {
        e.preventDefault();
        const $target = $(hash);
        const $headerHeight = $('.site-nav').height() + 40; // w/ added padding

        $('html, body').stop().animate({
          scrollTop: $target.offset().top - $headerHeight,
        }, 1000);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./client/js/utilities/SmoothScroll.js